import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { QualificationAction } from '../../../../domain/qualification';
import {
  APPLICATION_COMPLETE,
  APPLICATION_DENIED,
  APPLICATION_UNDER_REVIEW,
  BUSINESS_INFO_ONE,
  BUSINESS_INFO_TWO,
  COUNTER_OFFER,
  CREDIT_LOCKED,
  DOCUMENTS,
  FETCHING_BANK_DATA,
  FINANCIAL_STATEMENTS,
  FLEET_VERIFIED,
  GET_STARTED,
  PERSONA,
  PERSONAL_INFO,
  PREQUALIFIED,
  PREVIEW_CARD,
  PRE_COLLECT_UBOS,
  REVIEW_APPLICATION,
  SPEND_INTENT,
  VERIFY_REVENUE,
  VERIFY_REVENUE_DOCS,
  VERIFY_REVENUE_MX,
} from '../../../../paths';
import { RegistrationState, selectnextStep } from '../../../application/reducers/next-step';

const actionToPaths: Record<QualificationAction, Set<string>> = {
  collect_business_and_applicant_info: new Set([BUSINESS_INFO_ONE, BUSINESS_INFO_TWO, PERSONAL_INFO, SPEND_INTENT]),
  select_offer: new Set([PREQUALIFIED]),
  get_ubos: new Set([REVIEW_APPLICATION]),
  pre_collect_ubos: new Set([PRE_COLLECT_UBOS]),
  verify_ubos: new Set([REVIEW_APPLICATION]),
  preview_card_order: new Set([PREVIEW_CARD]),
  counter_offer: new Set([COUNTER_OFFER]),
  persona: new Set([PERSONA]),
  manual_review: new Set([APPLICATION_UNDER_REVIEW]),
  collect_documents: new Set([DOCUMENTS]),
  collect_financials: new Set([FINANCIAL_STATEMENTS]),
  unlock_consumer_credit: new Set([CREDIT_LOCKED]),
  declined: new Set([APPLICATION_DENIED]),
  approved: new Set([APPLICATION_COMPLETE]),
  verify_revenue: new Set([VERIFY_REVENUE, VERIFY_REVENUE_MX, VERIFY_REVENUE_DOCS]),
  verify_fetching_revenue: new Set([FETCHING_BANK_DATA]),
  verification_review: new Set([APPLICATION_UNDER_REVIEW]),
  verified: new Set([FLEET_VERIFIED]),
};

const pathsRelatedToAnAction = new Set<string>(Object.values(actionToPaths).flatMap((s) => [...s]));

const pathsNotRelatedToAnAction = new Set<string>([GET_STARTED]);

const pathActionMatch = ({
  pathname,
  nextStep: { action },
}: {
  pathname: string;
  nextStep: RegistrationState;
}): boolean => {
  if (pathsNotRelatedToAnAction.has(pathname)) {
    return true;
  }

  return pathsRelatedToAnAction.has(pathname) ? !!action && actionToPaths[action].has(pathname) : false;
};

const usePathActionMatch = () => {
  const { pathname } = useLocation();
  const nextStep = useSelector(selectnextStep);

  return pathActionMatch({ pathname, nextStep });
};

export { actionToPaths, pathActionMatch, usePathActionMatch };
